export const QuestionAskTo = {
  Purchaser: "Purchaser",
  Attendee: "Attendee"
};

export const QuestionDisplayType = {
  TextBox: "TextBox",
  DropdownList: "DropdownList",
  Checkbox: "CheckBox"
};

export const FacebookPageShareUrlWay = {
  SplashUrl: "SplashUrl",
  EventUrl: "EventUrl",
  CustomUrl: "CustomUrl"
};

export const RewardItem = {
  Ticket: "Ticket",
  Money: "Money"
};

export const RewardAccordingTo = {
  TicketQuantity: "TicketQuantity",
  MoneyAmount: "MoneyAmount"
};
